import { HitsProducts } from './ui/HitsProducts.jsx'
import './ui/HitsProducts.scss'

export default HitsProducts
